import StepBucket from "pattern/StepBucket.js";
import {findStep, findMinStep} from './utils.js';

export const expand = (group, stepBuckets, expandAmount) => {
    let steps = [...group.steps];
    let minStep = findMinStep(group, stepBuckets);
    steps.reverse();

    for (let step of steps) {
        let {stepNumber, position} = findStep(stepBuckets, step);
        let offset = stepNumber - minStep;
        let newStepNumber = Math.floor(minStep + offset * expandAmount);
        if (!stepBuckets[stepNumber]) {
            continue;
        }
        let stepsAtStepBucket = stepBuckets[stepNumber].steps;
        let track = stepBuckets[stepNumber].track;

        if (newStepNumber === stepNumber) {
            continue;
        }

        // delete the step
        stepBuckets[stepNumber]= new StepBucket(track);

        // add the step back at new step number (effectively moving it over by the
        // delay amount)
        stepBuckets[newStepNumber] = new StepBucket(track);
        stepBuckets[newStepNumber].steps = stepsAtStepBucket;
    }
    return stepBuckets;
};

